import ScrollCarousel from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-blog-featured-carousel-viewport]',
  track: '[data-blog-featured-carousel-track]',
};

const carousels = [];

export default function () {
  document.querySelectorAll('[data-blog-featured-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    const track = el.querySelector(SELECTORS.track);
    if (!track || track.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      // Flickity `wrapAround: true`; everything else was defaults.
      loop: true,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: 1,
      ariaLabel: 'Featured articles carousel',
    });

    carousels.push(carousel);
  });
}
